import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, CheckCircle2, Mail } from "lucide-react";
import { thankyou } from "../i18n/thankyou";

export default function ThankYou() {
  return (
    <main className="min-h-screen bg-white" data-testid="thank-you-page">
      <section className="border-b border-slate-200 bg-[#0B2447] text-white">
        <div className="mx-auto max-w-4xl px-4 py-20 sm:px-6 sm:py-24 lg:px-8">
          <p className="text-xs uppercase tracking-[0.22em] text-[#E0A78E]">
            {thankyou.eyebrow}
          </p>
          <h1 className="mt-6 font-serif text-4xl sm:text-5xl lg:text-6xl">
            {thankyou.title}
          </h1>
          <p className="mt-4 font-serif text-xl italic text-[#E0A78E] sm:text-2xl">
            {thankyou.subtitle}
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-4xl px-4 py-14 sm:px-6 sm:py-20 lg:px-8">
        <p className="text-base leading-relaxed text-slate-700 sm:text-lg">
          {thankyou.body}
        </p>

        <div className="mt-12 border border-slate-200 bg-[#F5F3EF] p-6 sm:p-8">
          <h2 className="font-serif text-2xl text-[#0B2447]">
            {thankyou.what_next_title}
          </h2>
          <ul className="mt-5 space-y-3 text-sm text-slate-700">
            {[thankyou.what_next_1, thankyou.what_next_2, thankyou.what_next_3].map(
              (item, i) => (
                <li key={i} className="flex gap-3">
                  <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-[#C56E4E]" aria-hidden />
                  <span>{item}</span>
                </li>
              )
            )}
          </ul>
        </div>

        <div className="mt-10 flex flex-col items-start gap-4 sm:flex-row sm:items-center sm:justify-between">
          <p className="flex items-center gap-2 text-sm text-slate-600">
            <Mail className="h-4 w-4 text-[#C56E4E]" aria-hidden />
            <span>{thankyou.contact_label}</span>
            <a
              href={`mailto:${thankyou.contact_value}`}
              className="text-[#0B2447] underline underline-offset-2"
              data-testid="thankyou-contact-link"
            >
              {thankyou.contact_value}
            </a>
          </p>
          <Link
            to="/"
            data-testid="thankyou-back-home-btn"
            className="inline-flex items-center gap-2 bg-[#0B2447] px-7 py-3 text-sm uppercase tracking-[0.14em] text-white hover:bg-[#0e2c58]"
          >
            <ArrowLeft className="h-4 w-4" aria-hidden />
            {thankyou.back_home}
          </Link>
        </div>
      </section>
    </main>
  );
}
